import { createFileRoute } from '@tanstack/react-router';
import { BrandingEditor } from '../../components/tenant/BrandingEditor';

export const Route = createFileRoute('/_authenticated/_layout/tenant/branding')({
    component: () => (
        <div className="space-y-4">
            <p className="text-sm text-muted-foreground">Personaliza colores y logo de tu tenant</p>
            <BrandingEditor />
        </div>
    ),
});
